<div class="ratInput" [formGroup]="form">
    <textarea type="text" class="form-control" [formControlName]="question?.quesId+'_id_'+controlIndex" #userinputbox
        [id]="question?.quesId+'_id_'+controlIndex" [placeholder]="eachControl?.label" (keyup)="handleKeyDown($event)"
        (blur)="inputChange($event, question?.quesId+'_id_'+controlIndex)" required [attr.disabled]="isDisabled"
        maxlength="4000" [ngClass]="isArabic ? 'rightAlign' : ''">
    </textarea>

    <!-- <input type="text" class="form-control" [formControlName]="question?.quesId+'_id_'+controlIndex" [id]="question?.quesId+'_id_'+controlIndex" [placeholder]="eachControl?.label"
    (blur)="inputChange($event, question?.quesId+'_id_'+controlIndex)" required [attr.disabled]="isDisabled" maxlength="2000"
    [ngClass]="isArabic ? 'rightAlign' : ''" (keydown)="checkBackslashEnter($event)"/> -->
</div>
<ng-container>
    <div class="error-container">
        <app-rat-errormsg [question]="question" [eachControl]="eachControl" [controlIndex]="controlIndex"
            [form]="form"></app-rat-errormsg>
    </div>
    <div class="count-text" [ngClass]="isArabic ? 'float-end' : 'float-start'">
        <ng-container *ngIf="!isArabic">Maximum allowed character is 4000.</ng-container>
        <ng-container *ngIf="isArabic">.أقصى حرف مسموح به هو 4000</ng-container>
    </div>
    <div class="count-text" [ngClass]="isArabic ? 'float-start' : 'float-end'">{{textCharCount}}/4000</div>
</ng-container>